import {NgModule, Component} from '@angular/core';
import {Input, Output,EventEmitter} from '@angular/core';
import {BrowserModule}   from '@angular/platform-browser';
import {DialogModule,ButtonModule} from 'primeng/primeng';



@Component({
    selector:'ex_dialog_ex',
    templateUrl:'./dialog_ex.component.html'
})
export class ExDialogExComponent{
    @Input() title:string;
    @Input() width: any;
    @Output() onSubmit:EventEmitter<any> = new EventEmitter();
    @Output() visibleChange:EventEmitter<any> = new EventEmitter();

    _visible: boolean;
    @Input() get visible(): boolean {
        return this._visible;
    }

    set visible(val:boolean) {
        this._visible = val;
        this.visibleChange.emit(val);
    }
    private onYes():void{
        this.visible = false;
        this.onSubmit.emit({originalEvent: event});
    }
    private onNo():void{
        this.visible = false;
    }
}


@NgModule({
    imports:[DialogModule,BrowserModule,ButtonModule],
    declarations:[ExDialogExComponent],
    exports:[ExDialogExComponent],
    providers:[]
})
export class ExDialogExModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/dialog_ex.component.ts